// extracted by mini-css-extract-plugin
module.exports = {"adminPanelContainer":"AdminPanel_adminPanelContainer__1gVSs"};